import React from 'react';
import { useHistory } from "react-router-dom";

const StoreText = ({image ,imageStyle , storeID})=>{
    console.log("image : ",image)
       return <div> 
    {!!image && image != '' && <img src={image} style={imageStyle?imageStyle:{ width: 40, height: 40,  borderRadius: 100,resizeMode: 'contain' }} />}
    </div>;
}

  export default StoreText;